import { Reveal, SectionHead, CheckItem, Chip, Avatar } from "../components/bits";

const FLOW = ["Past client", "Time passes", "Return window", "Personalised message", "Client reactivated", "Appointment booked"];

export const WhyReactivation = () => (
    <section id="why-reactivation" data-testid="why-reactivation" className="bg-sand/60 py-20 lg:py-24">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
            <div className="grid items-start gap-12 lg:grid-cols-2 lg:gap-16">
                <div>
                    <SectionHead
                        eyebrow="Why reactivation"
                        title="You already paid to acquire these clients once."
                        copy="A clinic can spend thousands every month generating new enquiries while past clients quietly disappear from the database. We think that’s backwards."
                    />
                    <div className="mt-8 grid gap-4 sm:grid-cols-2" data-testid="why-points">
                        {[
                            "Already know your clinic",
                            "Already trusted you",
                            "Already purchased from you",
                            "May simply need a reason to return",
                        ].map((t, i) => (
                            <Reveal key={t} delay={i * 0.08}>
                                <div className="flex h-full items-center rounded-xl border border-linen bg-ivory px-4 py-3.5 card-lift">
                                    <CheckItem>{t}</CheckItem>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>

                <Reveal delay={0.15}>
                    <div className="grain relative overflow-hidden rounded-3xl bg-ink p-7 sm:p-9">
                        <div className="font-serif text-2xl uppercase leading-tight tracking-tight text-cream sm:text-3xl">
                            Make more from the database you <span className="italic text-gold">already built.</span>
                        </div>
                        <div className="relative mt-8">
                            <div className="absolute left-[19px] top-2 bottom-2 w-px">
                                <svg className="h-full w-2" preserveAspectRatio="none">
                                    <line x1="4" y1="0" x2="4" y2="100%" stroke="#CBA368" strokeOpacity="0.3" strokeWidth="1" className="line-flow" />
                                </svg>
                            </div>
                            <div className="space-y-4">
                                {FLOW.map((t, i) => (
                                    <Reveal key={t} delay={0.1 + i * 0.09}>
                                        <div className="relative flex items-center gap-4">
                                            <span
                                                className={`z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border font-mono text-[10px] ${
                                                    i >= 4
                                                        ? "border-gold/60 bg-gold/15 text-gold"
                                                        : "border-cream/15 bg-charcoal text-cream/60"
                                                }`}
                                            >
                                                {String(i + 1).padStart(2, "0")}
                                            </span>
                                            <div
                                                className={`flex flex-1 items-center justify-between rounded-xl border px-4 py-3 ${
                                                    i >= 4 ? "border-gold/30 bg-charcoal" : "border-cream/10 bg-matte"
                                                }`}
                                            >
                                                <span className="font-sans text-[13px] uppercase tracking-[0.1em] text-cream/85">{t}</span>
                                                {i === 3 && <span className="font-mono text-[8px] uppercase tracking-widest text-rose">SMS ✓</span>}
                                                {i === 5 && <span className="font-mono text-[8px] uppercase tracking-widest text-gold">Booked ✓</span>}
                                            </div>
                                        </div>
                                    </Reveal>
                                ))}
                            </div>
                        </div>
                        <div className="mt-7 flex items-center gap-3 border-t border-cream/10 pt-5">
                            <Avatar initials="S" tone="bg-blush text-ink" />
                            <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-cream/45">
                                The same client — back on the calendar
                            </span>
                        </div>
                    </div>
                </Reveal>
            </div>

            <Reveal delay={0.1} className="mt-12 flex flex-wrap items-center justify-center gap-2.5">
                {FLOW.map((t, i) => (
                    <div key={t} className="flex items-center gap-2.5">
                        {i > 0 && <span className="font-mono text-[10px] text-gold">→</span>}
                        <Chip>{t}</Chip>
                    </div>
                ))}
            </Reveal>
        </div>
    </section>
);
